module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-aure-wood-noce-canaletto-milled.40a27820.jpg";